import React, { useState, useCallback } from "react";
import { Tab, Nav } from "react-bootstrap";
import { Spin } from "@arco-design/web-react";
import Layout from "../../Components/Layout/Layout";
import BackBtn from "../../Components/BackBtn/BackBtn";
import NewChits from "./NewChits"; // Your existing component
import { useLocation, useNavigate } from "react-router-dom";
import NewSubstitutionChits from "./NewSubstitutionChits";

function NewChitsHome() {
  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state;
  const is_unregister_user = state?.is_unregister_user;

  const [TabIndex, setTabIndex] = useState(0);

  const handleTabChange = useCallback((index) => {
    setTabIndex(index);
  }, []);

  const handleBackBtn = () => {
    if (is_unregister_user) {
      navigate("/quick-verify?next=/newchits", { replace: true });
    } else {
      if (
        window.history.state?.idx === 0 ||
        window.history.state === null ||
        !is_unregister_user
      ) {
        navigate("/");
      } else navigate(-1);
    }
  };

  const renderContent = () => (
    <div className="pt-3 pb-4 px-3 px-md-4 overflow-auto custom_scroll1">
      <div>
        <div className="mb-3">
          <div className="align-items-center d-flex justify-content-between flex-wrap">
            <BackBtn
              title={"New Chits"}
              handleBackBtn   ={handleBackBtn}
            />
          </div>
        </div>

        <div className="p-3 bg-white br_10 shadow_sm">
          <Tab.Container defaultActiveKey="TabOne">
            <div className="mb-2 mb-sm-3 d-flex justify-content-between align-items-center">
              <Nav
                className="gap-2 gap-sm-3 nav-tabs nav_tab_t3"
                activeKey={TabIndex}
              >
                <Nav.Item className="flex-fill flex-sm-grow-0">
                  <Nav.Link
                    eventKey="TabOne"
                    onClick={() => handleTabChange(0)}
                  >
                    New Chits
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item className="flex-fill flex-sm-grow-0">
                  <Nav.Link
                    eventKey="TabTwo"
                    onClick={() => handleTabChange(1)}
                  >
                    Substitution Chits
                  </Nav.Link>
                </Nav.Item> 
              </Nav>
            </div>

            <Tab.Content>
              <Tab.Pane eventKey="TabOne">
                {TabIndex === 0 && <NewChits is_unregister_user={is_unregister_user} />}
              </Tab.Pane>
              <Tab.Pane eventKey="TabTwo">
                {TabIndex === 1 && <NewSubstitutionChits is_unregister_user={is_unregister_user} />}
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>
      </div>
    </div>
  );

  return (
    <>
      {!is_unregister_user ? (
        <Layout>{renderContent()}</Layout>
      ) : (
        <Spin className="position-absolute w-100 h-100">
          {renderContent()}
        </Spin>
      )}
    </>
  );
}

export default NewChitsHome;
